export interface SessionMonitorConfig {
    enabled: boolean;
    reloginThresholdMs: number;
    logoutThresholdMs: number;
}

export const DEFAULT_SESSION_MONITORING_CONFIG: SessionMonitorConfig = {
    enabled: true,
    reloginThresholdMs: 15 * 60 * 1000,
    logoutThresholdMs: 40 * 60 * 1000
};
